export default __webpack_public_path__ + "static/media/1.3535ea23.jpg";